import {Injectable} from '@angular/core';
import {BaseService} from '../../base/base.service';
import {ReportModel} from '../../../models/report/report.model';
import {ReportFilter} from '../../../models/report-filter/report.filter';

declare var excelExport: any;

@Injectable()
export class ReportService extends BaseService {
    public reportData: Array<ReportModel>;
    public filterForm: ReportFilter;

    constructor() {
        super();
        this.reportData = [];
        this.filterForm = {asset_id: '', date: '', end_date: '', user_id: '', time: 0, distance: 0, trip_time: 0};
    }

    public index(userId = null) {
        this.requestUrl = this.generateUrl('user.child.list');
        if (userId) {
            this.requestUrl += '?user_id=' + userId;
        }
        return this.request(null);
    }

    public assets(userId = null) {
        this.requestUrl = this.generateUrl('user.asset.list');
        if (userId) {
            this.requestUrl += '?user_id=' + userId;
        }
        return this.request(null);
    }

    public exportReportFn(id) {
        excelExport(id, id);
    }

    public user(data) {
        this.requestUrl = this.getUrl('user', data);
        return this.request(null);
    }

    public park_maintenance(data) {
        this.requestUrl = this.getUrl('park_maintenance', data);
        return this.request(null);
    }

    public asset(data) {
        this.requestUrl = this.getUrl('asset', data);
        return this.request(null);
    }

    public assetEventList() {
        this.requestUrl = this.generateUrl('asset.events');
        return this.request(null);
    }

    public nr(data) {
        this.requestUrl = this.getUrl('nr', data);
        return this.request(null);
    }

    public liveAsset(data) {
        this.requestUrl = this.getUrl('live', data);
        return this.request(null);
    }

    public distance(data) {
        this.requestUrl = this.getUrl('distance', data);
        return this.request(null);
    }

    public gateOut(data) {
        this.requestUrl = this.getUrl('gate_out', data);
        return this.request(null);
    }

    public gateIn(data) {
        this.requestUrl = this.getUrl('gate_in', data);
        return this.request(null);
    }

    public fieldTime(data) {
        this.requestUrl = this.getUrl('field_time', data);
        return this.request(null);
    }

    public outVehicle(data) {
        this.requestUrl = this.getUrl('out_vehicle', data);
        return this.request(null);
    }

    public notOutVehicle(data) {
        this.requestUrl = this.getUrl('not_out_vehicle', data);
        return this.request(null);
    }

    public tripSummary(filters) {
        this.requestUrl = this.applyFilter('trip_summary', filters);
        return this.request(null);
    }

    public tripDetail(filters) {
        this.requestUrl = this.applyFilter('trip_detail', filters);
        return this.request(null);
    }

    public stop(filters) {
        this.requestUrl = this.applyFilter('stop', filters);
        return this.request(null);
    }

    public vanWiseSummary(filters) {
        this.requestUrl = this.applyFilter('van-wise-summary', filters);
        return this.request(null);
    }

    public branchWiseSummary(filters) {
        this.requestUrl = this.applyFilter('branch-wise-summary', filters);
        return this.request(null);
    }

    public tripWise(filters) {
        this.requestUrl = this.applyFilter('trip-wise', filters);
        return this.request(null);
    }

    public movingInFence(filters) {
        this.requestUrl = this.applyFilter('moving_in_fence', filters);
        return this.request(null);
    }

    public movingOutFence(filters) {
        this.requestUrl = this.applyFilter('moving_out_fence', filters);
        return this.request(null);
    }

    public offWorkTimeFence(filters) {
        this.requestUrl = this.applyFilter('off_work_time', filters);
        return this.request(null);
    }

    public totalTripsFence(filters) {
        this.requestUrl = this.applyFilter('total_trips', filters);
        return this.request(null);
    }

    private applyFilter(key, filters) {
        return this.generateUrl('reports.' + key) + '?' + this.getTemplateHelper().ObjectToQueryParams(filters);
    }

    private getUrl(key, data) {
        return this.generateUrl('reports.' + key) + '?' + this.getTemplateHelper().ObjectToQueryParams(data);
    }
}
